import { render, staticRenderFns } from "./getpsc-box1.vue?vue&type=template&id=3bd085ff&scoped=true&"
import script from "./getpsc-box1.vue?vue&type=script&lang=js&"
export * from "./getpsc-box1.vue?vue&type=script&lang=js&"
import style0 from "./getpsc-box1.vue?vue&type=style&index=0&id=3bd085ff&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bd085ff",
  null
  
)

export default component.exports